import { useUserRoutes } from '@cosuno/authentication-frontend';
import { useMatch } from 'react-router-dom';

const useMatchesExclusionRoutes = () => {
  const routes = useUserRoutes();

  const matchesCompanyRoute = useMatch({ path: routes.company(), end: false }) !== null;
  const matchesCompanyPremiumRoute = useMatch({ path: routes.premium(), end: false }) !== null;
  const matchesSubcontractorCreateBidRoute =
    useMatch({ path: routes.subcontractorCreateBid(), end: false }) !== null;
  const matchesBidRequestDeclinePageRoute =
    useMatch({ path: routes.bidInviteAction(':bidInviteId', ':action'), end: false }) !== null;
  const matchesBidRequestLandingPageRoute =
    useMatch({
      path: routes.bidRequestLandingPage(),
      end: true,
    }) !== null;
  const matchesBidRequestTermsPageRoute =
    useMatch({ path: routes.bidRequestAcceptTerms(), end: false }) !== null;
  const matchesAgentMarketplaceSamples =
    useMatch({ path: routes.agentUnauthenticatedMarketplaceSamples(), end: false }) !== null;
  const matchesReverseMarketplace =
    useMatch({ path: routes.reverseMarketplaceBidPackage(), end: false }) !== null;
  const matchesReverseMarketplaceSuggestion =
    useMatch({ path: routes.agentReverseMarketplaceSuggestion(), end: false }) !== null;
  const matchesMessagesRoute = useMatch({ path: routes.messages(), end: false }) !== null;
  const matchesAgentSignContractRoute =
    useMatch({ path: routes.agentSignContract(), end: false }) !== null;
  const matchesAgentCompanyOnboarding =
    useMatch({ path: routes.agentCompanyOnboarding(), end: false }) !== null;
  const matchesAgentCompleteRegistration =
    useMatch({ path: routes.agentCompleteRegistration(), end: false }) !== null;

  return (
    matchesCompanyRoute ||
    matchesSubcontractorCreateBidRoute ||
    matchesBidRequestDeclinePageRoute ||
    matchesBidRequestLandingPageRoute ||
    matchesBidRequestTermsPageRoute ||
    matchesAgentMarketplaceSamples ||
    matchesReverseMarketplace ||
    matchesReverseMarketplaceSuggestion ||
    matchesMessagesRoute ||
    matchesAgentSignContractRoute ||
    matchesCompanyPremiumRoute ||
    matchesAgentCompanyOnboarding ||
    matchesAgentCompleteRegistration
  );
};

export default useMatchesExclusionRoutes;
